export default __webpack_public_path__ + "static/media/banner2_mobile_fallback.146c06c2.jpg";